// @flow

/* @see https://git.invia.io/post-retention/invia-booking-hub/customer-interaction-area/backend/-/blob/develop/pkg/constant/errorType.go */

export const ERROR_TYPE_CONNECTION = "connection";
export const ERROR_TYPE_UNKNOWN = "unknown";
